<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>个人资料</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="sidebar">
        <div class="avatar">
          <img src="../../assets/images/avatar.jpg" />
          <div class="name">
            <!--<h3>张明翰</h3>-->
            <p>185****5678</p>
          </div>
        </div>
        <ul class="menu">
          <li>
            <router-link to="/account/ticket-order">
              <img src="../../assets/images/icon-order.png" />
              <span>票务订单</span>
            </router-link>
          </li>
          <li>
            <router-link to="/account/mall-order">
              <img src="../../assets/images/icon-order.png" />
              <span>商城订单</span>
            </router-link>
          </li>
          <li>
            <router-link to="/account/contacts">
              <img src="../../assets/images/icon-contacts.png" />
              <span>常用联系人</span>
            </router-link>
          </li>
          <li class="active">
            <router-link to="/account/profile">
              <img src="../../assets/images/icon-profile-active.png" />
              <span>个人资料</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="main">
        <div class="main-title">
          <h2>个人资料</h2>
        </div>
        <div class="profile">
          <div class="tips">
            <p>
              1、请确保您填写的信息真实、准确、完整。会员信息成功保存后将不能更改！同时将保证您的信息安全，您的个人信息将不会被使用于非相关业务中。
            </p>
            <p>
              2、会员用以注册的手机号码须已经过运营商实名登记。如使用虚拟手机号码、不实姓名等无法与其真实身份相对应的信息申请会员注册的，其注册申请将被拒绝，或已经取得注册的其会员资格将被注销。
            </p>
            <p>
              3、您的姓名、身份证信息填写错误将导致购买的产品无法验证使用及入园。
            </p>
            <p>
              4、如因所提交信息资料不实、错误所造成任何损失的，均由会员本人承担，请谨慎填写。
            </p>
          </div>
          <el-form
            :model="profileForm"
            :rules="rules"
            ref="profileForm"
            label-width="100px"
            class="profile-form"
          >
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="profileForm.name"
                placeholder="请输入真实姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="gender">
              <el-radio-group v-model="profileForm.gender">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="证件类型" prop="idType">
              <el-select
                v-model="profileForm.idType"
                placeholder="请选择证件类型"
              >
                <el-option label="身份证" value="shenfenzheng"></el-option>
                <el-option label="护照" value="huzhao"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号" prop="idNumber">
              <el-input
                v-model="profileForm.idNumber"
                placeholder="请输入证件号码"
              ></el-input>
            </el-form-item>
            <el-form-item label="生日" required>
              <el-form-item prop="date">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="profileForm.date"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="profileForm.phone" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('profileForm')"
                >确定</el-button
              >
              <el-button @click="resetForm('profileForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      profileForm: {
        name: '',
        gender: '',
        idType: '',
        idNumber: '',
        date: '',
        phone: '18512345678',
      },
      rules: {
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        idType: [
          { required: true, message: '请选择证件类型', trigger: 'change' },
        ],
        idNumber: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
        ],
        date: [
          {
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrapper {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  text-align: left;
}
.sidebar {
  width: 280px;
  padding: 20px 0;
  border-radius: 10px;
  background: #fff;
  .avatar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 30px;
    .name {
      margin-left: 16px;
      h3 {
        margin-bottom: 5px;
        font-size: 18px;
      }
    }
  }
  .menu {
    li {
      height: 50px;
      padding: 0 0 0 30px;
      font-size: 16px;
      line-height: 50px;
      a {
        display: block;
        color: #191b26;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    li.active {
      border-right: 2px solid #31a775;
      color: #31a775;
      background: #f6fcf9;
      a {
        color: #31a775;
      }
    }
  }
}
.main {
  width: 900px;
  .main-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    line-height: 40px;
    h2 {
      border-bottom: 2px solid #31a775;
      color: #31a775;
      font-weight: normal;
      font-size: 16px;
    }
    a {
      color: #31a775;
      font-size: 16px;
    }
  }
  .profile {
    padding: 40px;
    border-radius: 10px;
    background: #fff;
    .tips {
      margin-bottom: 40px;
      color: #f15b49;
      line-height: 24px;
    }
    .profile-form {
      width: 400px;
    }
    .profile-form /deep/ .el-select .el-input {
      width: 300px;
    }
    .profile-form /deep/ .el-radio__input.is-checked .el-radio__inner {
      border-color: #31a775;
      background: #31a775;
    }
    .profile-form /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #31a775;
    }
    .el-button--primary {
      border-color: #31a775;
      background-color: #31a775;
    }
  }
}
</style>
